import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { GcssLayout } from '@/components/layout/GcssLayout';
import { ResultContent } from '@/sections/gcss/ResultContent';
import { getAllSubCategoriesPaths, getSubCategoryBySlug } from '@/sections/gcss/functions/getSubcategories';
import type { SubCategory } from '@/sections/gcss/functions/utils';
import { getNoResultsData, type NoResults } from '@/sections/gcss/functions/getNoResultsData';
import { useGcssValuesToSearch } from '@/sections/gcss/hooks/useGcssSearch';
import { type IntlProps, getIntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { getHeaderSections } from '@/sections/gcss/functions/getHeaderSections';
import { Section } from '@/sections/layout/Header/useGcssSections';
import { isAllowedRoute } from '@/lang/pagesConfig';
interface Props extends IntlProps {
  subCategory: SubCategory;
  noResultsData: NoResults;
  headerSections: Section[];
}
export default function Page(props) {
  const $ = _c(14);
  const {
    subCategory,
    noResultsData,
    headerSections
  } = props;
  let t0;
  if ($[0] !== subCategory.name || $[1] !== subCategory.slug) {
    t0 = {
      title: subCategory.name,
      url: subCategory.slug,
      level: "1"
    };
    $[0] = subCategory.name;
    $[1] = subCategory.slug;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  usePageView("gcss-subcategory", t0);
  const {
    formValues,
    sync,
    searchForm
  } = useGcssValuesToSearch();
  let t1;
  if ($[3] !== formValues || $[4] !== noResultsData || $[5] !== searchForm || $[6] !== subCategory || $[7] !== sync) {
    t1 = <ResultContent noResultsData={noResultsData} searchForm={searchForm} formValues={formValues} sync={sync} category={subCategory} />;
    $[3] = formValues;
    $[4] = noResultsData;
    $[5] = searchForm;
    $[6] = subCategory;
    $[7] = sync;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== formValues || $[10] !== headerSections || $[11] !== searchForm || $[12] !== t1) {
    t2 = <GcssLayout headerSections={headerSections} searchForm={searchForm} formValues={formValues}>{t1}</GcssLayout>;
    $[9] = formValues;
    $[10] = headerSections;
    $[11] = searchForm;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}
export const getStaticPaths = async () => {
  return {
    paths: await getAllSubCategoriesPaths(1),
    fallback: false
  };
};
export const getStaticProps = (async ctx => {
  const isAllowed = isAllowedRoute('srovnavac-produktu/[:category]/[:subcategoryLevelOne]');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  const slug = (ctx.params?.subcategoryLevelOne as string).toLowerCase();
  const subCategory = await getSubCategoryBySlug(slug, 1);
  if (!subCategory) {
    throw new Error(`Subcategory not found - ${slug}`);
  }
  return {
    props: {
      subCategory,
      noResultsData: await getNoResultsData(),
      headerSections: await getHeaderSections(),
      ...(await getIntlProps(ctx, ['gcss']))
    }
  };
}) satisfies GetStaticProps<Props>;